import { render, staticRenderFns } from "./add-order-for-bill.vue?vue&type=template&id=07bac25d"
import script from "./add-order-for-bill.vue?vue&type=script&lang=js"
export * from "./add-order-for-bill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports